module.exports = __webpack_public_path__ + "img/55.5eabc460.png";